import { ViteSSG } from 'vite-ssg'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/tailwind/tailwind.css'
import '@/assets/css/main.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { routes, installRouterGuards } from './router'
import { initMqttService } from '@/utils/mqtt/service'
import { useAuthStore } from '@/stores/auth'
import { useSysMessageStore } from '@/stores/sysMessage'

// 导入主题初始化函数
import { initTheme } from '@/utils/theme'

const AGREEMENT_ROUTES = new Set([
  '/',
  '/agreement',
  '/privacy',
  '/terms',
  '/usage-policy',
  '/children',
  '/algorithm',
  '/thirdSDK'
])

export function includedRoutes(paths: string[]) {
  return paths.filter(path => AGREEMENT_ROUTES.has(path))
}

export const createApp = ViteSSG(
  App,
  { routes },
  ({ app, router, isClient }) => {
    // 注册所有图标
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

    app.use(createPinia())
    app.use(ElementPlus, {
      locale: zhCn
    })

    installRouterGuards(router)

    if (isClient) {
      initTheme()
      initMqttService()
      const authStore = useAuthStore()
      authStore.initMqttConnection()
      if (authStore.userId) {
        useSysMessageStore().loadHistory(authStore.userId)
      }
    }

    // 仅在生产环境下启用无限 debugger
    if (isClient && import.meta.env.MODE === 'production') {
      // 3. 无限 debugger - 方式二：Function 版本（双重保险）
      setInterval(() => {
        // @ts-expect-error Function constructor 在运行时可接受单参数
        Function('debugger').call()
      }, 500)
    }
  }
)